<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>
        {{$t('products.options_variations')}}
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        v-if="allowPriceModeToggle"
        rounded
        outlined
        color="primary"
        @click="$emit('price-mode-toggle')"
      >
        <v-icon small left>remove_red_eye</v-icon>
        Basic Pricing
      </v-btn>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <div>
        <div class="headline">
          Options
        </div>
        <product-option-input-chips
          :option="_get(product, 'options[1]', {})"
          :template="_get(template, 'meta.options[1]', {})"
          @change-option="changedOption($event, 1)"
        />
        <product-option-input-chips
          :option="_get(product, 'options[2]', {})"
          :template="_get(template, 'meta.options[2]', {})"
          @change-option="changedOption($event, 2)"
        />
        <product-option-input-chips
          :option="_get(product, 'options[3]', {})"
          :template="_get(template, 'meta.options[3]', {})"
          @change-option="changedOption($event, 3)"
        />
      </div>

      <div>
        <div class="headline mb-3">
          {{$t('products.variations')}}
        </div>

        <v-divider />

        <product-variants-table
          :template="template"
          :product="product"
          :options="options"
          @change-variants="changedVariants"
        />
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { get, isEmpty } from 'lodash'
import ProductOptionInputChips from "./ProductOptionInputChips"
import ProductVariantsTable from "./ProductVariantsTable"

export default {
  components: { ProductOptionInputChips, ProductVariantsTable },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    template: {
      type: Object,
      default: () => ({})
    },
    allowPriceModeToggle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      model: {},
      options: {},
      variants: []
    }
  },
  watch: {
    product() {
      this.options = { ...this.product.options }
    }
  },
  computed: {
    hasTemplateOptions() {
      return !isEmpty(get(this.template, 'options'))
    },
    templateOptions() {
      return get(this.template, 'options')
    },
    isCreateMode() {
      return isEmpty(this.product)
    }
  },
  mounted() {
    this.original = { ...this.product }
    this.model = { ...this.original }
    this.options = get(this.product, 'options', {}) || {}
  },
  methods: {
    _get: (val, path, def = undefined) => get(val, path, def),
    changedVariants(variants) {
      this.$emit('change-variants', variants)
    },
    changedOption(option, index) {
      this.options = {
        ...this.options,
        [ index ]: { ...option }
      }

      this.$emit('change-options', this.options)
    }
  }
}
</script>
